import React, { useEffect, useState, useContext } from "react";
import { ApiUrlContext } from "../App";

export default function Panel() {
  const apiUrl = useContext(ApiUrlContext);

  const [contact, setContact] = useState({ name: "", email: "", subject: "", message: "" });
  const [contactStatus, setContactStatus] = useState({ loading: false, success: null, error: null });
  
  // Slider için state
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Slider fotoğrafları
  const sliderImages = [
    {
      id: 1,
      url: `${process.env.PUBLIC_URL}/ihhanasayfa1.jpg`,
      
    },
    {
      id: 2,
      url: `${process.env.PUBLIC_URL}/ihhanasayfa2.jpg`,
    
    },
    {
      id: 3,
      url: `${process.env.PUBLIC_URL}/ihhanasayfa3.jpg`,
      
    }
    
  ];

  

  // Slider otomatik geçiş efekti
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
    }, 3000); // 3 saniyede bir geçiş

    return () => clearInterval(interval);
  }, [sliderImages.length]);

  // Bir sonraki slide'a git
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
  };

  // Bir önceki slide'a git
  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
  };

  // Belirli bir slide'a git
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div style={styles.container} className="panel-container">
      <style>{`
        @media (max-width: 1024px) {
          .panel-slider { height: 320px; }
          .panel-contact-row { flex-direction: column; gap: 12px; }
        }
        @media (max-width: 768px) {
          .panel-container { padding: 0 14px 28px; }
          .panel-slider { height: 260px; }
          .panel-slide-title { font-size: 22px !important; }
          .panel-slide-desc { font-size: 14px !important; }
          .panel-info { padding: 18px !important; }
          .panel-contact-row { flex-direction: column; gap: 12px; }
          .panel-contact-input { width: 100% !important; }
        }
        @media (max-width: 480px) {
          .panel-slider { height: 220px; }
          .panel-slide-overlay { padding: 24px !important; }
        }
      `}</style>
      {/* Slider Bölümü */}
      <section style={styles.sliderContainer} className="panel-slider">
        <div style={styles.slider}>
          {sliderImages.map((image, index) => (
            <div
              key={image.id}
              style={{
                ...styles.slide,
                opacity: index === currentSlide ? 1 : 0,
                transform: `translateX(${(index - currentSlide) * 100}%)`,
              }}
            >
              <img 
                src={image.url} 
                alt={image.title}
                style={styles.slideImage}
              />
              <div style={styles.slideOverlay} className="panel-slide-overlay">
                <h2 style={styles.slideTitle} className="panel-slide-title">{image.title}</h2>
                <p style={styles.slideDescription} className="panel-slide-desc">{image.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        {/* Slider Navigasyon Butonları */}
        <button 
          onClick={prevSlide} 
          style={styles.sliderButton.prev}
          aria-label="Önceki fotoğraf"
        >
          ‹
        </button>
        <button 
          onClick={nextSlide} 
          style={styles.sliderButton.next}
          aria-label="Sonraki fotoğraf"
        >
          ›
        </button>
        
        {/* Slider Dots (Noktalar) */}
        <div style={styles.dotsContainer}>
          {sliderImages.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              style={styles.dot(index === currentSlide)}
              aria-label={`Slide ${index + 1}`}
            />
          ))}
        </div>
      </section>

      {/* How to Join Section */}
      <section style={styles.infoCard}>
        <h3 style={styles.infoTitle}>Nasıl Katılabilirsiniz?</h3>
        <p style={styles.infoText}>
          İlgili kursun detay sayfasına gidip kayıt olabilirsiniz. Kayıt gerektiren kurslarda başvuru adımları ve iletişim bilgileri paylaşılacaktır. Daha fazla bilgi için iletişim bölümünü kullanın.
        </p>
      </section>

      {/* Additional Info Section */}
      <section style={styles.additionalSection}>
        <h3 style={styles.additionalTitle}>Eğitim Programlarımızın Amacı</h3>
        <p style={styles.additionalText}>
          IHH olarak eğitim programlarımızla, dezavantajlı bölgelerdeki bireylere mesleki beceriler kazandırmayı ve sürdürülebilir kalkınmaya katkı sağlamayı hedefliyoruz. Kurslarımız, alanında uzman eğitmenler tarafından verilmekte ve teorik bilginin yanı sıra pratik uygulamalara da yer vermektedir. Katılımcılarımız, eğitim sonunda edindikleri becerileri günlük hayatta kullanabilmekte ve toplumlarına faydalı olabilmektedir.
        </p>
      </section>

      {/* Contact Section */}
      <section style={styles.contactCard}>
        <h3 style={styles.contactTitle}>İletişim / Daha fazla bilgi</h3>
        <p style={styles.contactDescription}>
          Sorularınız veya bilgi talepleriniz için aşağıdaki formu doldurun.
        </p>

        <form
          style={styles.contactForm}
          onSubmit={async (e) => {
            e.preventDefault();
            setContactStatus({ loading: true, success: null, error: null });
            if (!contact.name.trim() || !contact.email.trim() || !contact.message.trim()) {
              setContactStatus({ loading: false, success: null, error: 'Lütfen ad, e-posta ve mesaj alanlarını doldurun.' });
              return;
            }
            try {
              const res = await fetch(`${apiUrl}/contact`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(contact)
              });
              if (res.ok) {
                setContactStatus({ loading: false, success: 'Mesajınız alındı. Teşekkürler!', error: null });
                setContact({ name: '', email: '', subject: '', message: '' });
              } else {
                const data = await res.json().catch(() => ({}));
                setContactStatus({ loading: false, success: null, error: data.error || 'Gönderilirken hata oluştu.' });
              }
            } catch (err) {
              console.error(err);
              setContactStatus({ loading: false, success: null, error: 'Sunucuya ulaşılamadı.' });
            }
          }}
        >
          <div style={styles.formRow} className="panel-contact-row">
            <input
              placeholder="Adınız"
              value={contact.name}
              onChange={(e) => setContact(prev => ({ ...prev, name: e.target.value }))}
              style={styles.formInput}
              className="panel-contact-input"
            />
            <input
              placeholder="E-posta adresiniz"
              value={contact.email}
              onChange={(e) => setContact(prev => ({ ...prev, email: e.target.value }))}
              style={styles.formInput}
              className="panel-contact-input"
            />
          </div>
          <input
            placeholder="Konu (isteğe bağlı)"
            value={contact.subject}
            onChange={(e) => setContact(prev => ({ ...prev, subject: e.target.value }))}
            style={styles.formInput}
          />
          <textarea
            placeholder="Mesajınız"
            value={contact.message}
            onChange={(e) => setContact(prev => ({ ...prev, message: e.target.value }))}
            rows={3}
            style={styles.formTextarea}
          />
          <div style={styles.formActions}>
            <button
              type="submit"
              disabled={contactStatus.loading}
              style={styles.submitButton(contactStatus.loading)}
            >
              {contactStatus.loading ? 'Gönderiliyor…' : 'Gönder'}
            </button>
            {contactStatus.error && <div style={styles.errorMessage}>{contactStatus.error}</div>}
            {contactStatus.success && <div style={styles.successMessage}>{contactStatus.success}</div>}
          </div>
        </form>
      </section>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px 32px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    background: '#f7f7f7',
    minHeight: '100vh',
  },
  sliderContainer: {
    position: 'relative',
    height: '400px',
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '32px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
  },
  slider: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  slide: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    transition: 'opacity 0.5s ease, transform 0.5s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  slideImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  slideOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
    color: 'white',
    padding: '40px',
    paddingTop: '80px',
  },
  slideTitle: {
    fontSize: '32px',
    fontWeight: 'bold',
    margin: '0 0 10px 0',
    textShadow: '1px 1px 3px rgba(0,0,0,0.5)',
  },
  slideDescription: {
    fontSize: '18px',
    margin: 0,
    opacity: 0.9,
    textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
  },
  sliderButton: {
    prev: {
      position: 'absolute',
      top: '50%',
      left: '20px',
      transform: 'translateY(-50%)',
      background: 'rgba(0,0,0,0.5)',
      color: 'white',
      border: 'none',
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      fontSize: '24px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background 0.3s',
      ':hover': {
        background: 'rgba(0,0,0,0.8)',
      }
    },
    next: {
      position: 'absolute',
      top: '50%',
      right: '20px',
      transform: 'translateY(-50%)',
      background: 'rgba(0,0,0,0.5)',
      color: 'white',
      border: 'none',
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      fontSize: '24px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'background 0.3s',
      ':hover': {
        background: 'rgba(0,0,0,0.8)',
      }
    }
  },
  dotsContainer: {
    position: 'absolute',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: '10px',
  },
  dot: (isActive) => ({
    width: isActive ? '12px' : '8px',
    height: isActive ? '12px' : '8px',
    borderRadius: '50%',
    background: isActive ? 'white' : 'rgba(255,255,255,0.5)',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    transition: 'all 0.3s ease',
    ':hover': {
      background: 'white',
      transform: 'scale(1.2)',
    }
  }),
  infoCard: {
    background: '#fff',
    borderRadius: '12px',
    padding: '24px',
    border: '1px solid #eee',
    marginBottom: '24px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  infoTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
    margin: '0 0 12px 0',
  },
  infoText: {
    fontSize: '14px',
    color: '#555',
    lineHeight: '1.6',
    margin: '0',
  },
  additionalSection: {
    background: '#fff',
    borderRadius: '12px',
    padding: '24px',
    border: '1px solid #eee',
    marginBottom: '24px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  additionalTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
    margin: '0 0 12px 0',
  },
  additionalText: {
    fontSize: '14px',
    color: '#555',
    lineHeight: '1.6',
    margin: '0',
  },
  contactCard: {
    background: '#fff',
    borderRadius: '12px',
    padding: '24px',
    border: '1px solid #eee',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  contactTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
    margin: '0 0 8px 0',
  },
  contactDescription: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '20px',
    lineHeight: '1.5',
  },
  contactForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  formRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
  },
  formInput: {
    padding: '10px 12px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
    background: '#f8f9fa',
    transition: 'border-color 0.2s',
    ':focus': {
      outline: 'none',
      borderColor: '#6a77bb',
    }
  },
  formTextarea: {
    padding: '10px 12px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
    background: '#f8f9fa',
    resize: 'vertical',
    minHeight: '80px',
    fontFamily: 'inherit',
    transition: 'border-color 0.2s',
    ':focus': {
      outline: 'none',
      borderColor: '#6a77bb',
    }
  },
  formActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  submitButton: (isLoading) => ({
    padding: '10px 24px',
    background: isLoading ? '#a5b4fc' : '#6a77bb',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: isLoading ? 'not-allowed' : 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    ':hover': isLoading ? {} : {
      backgroundColor: '#5a67a5',
    }
  }),
  errorMessage: {
    color: '#dc3545',
    fontSize: '14px',
    fontWeight: '500',
  },
  successMessage: {
    color: '#28a745',
    fontSize: '14px',
    fontWeight: '500',
  },
};

// CSS Animasyonu
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);
